.button {
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: var(--radius-sharp);
  border: 1px solid transparent;
  cursor: pointer;
  line-height: 1.2;
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.primary {
  background: var(--teal-600);
  color: var(--card);
  border-color: var(--teal-700);
}

.primary:hover:not(:disabled) {
  background: var(--teal-700);
}

.secondary {
  background: var(--card);
  color: var(--ink);
  border-color: var(--line);
}

.secondary:hover:not(:disabled) {
  border-color: var(--rule-strong);
}

.danger {
  background: var(--card);
  color: var(--stop);
  border-color: var(--stop);
}

.danger:hover:not(:disabled) {
  background: color-mix(in srgb, var(--stop) 8%, var(--card));
}
